function Influences() {
    return (
      <div className="text-left">
        <h2 class="bottom-line">Influences</h2>
        <h4>Favorite Artists</h4>
        <p>The Beatles, Led Zeppelin, Alice in Chains, The Rolling Stones, Cream, David Bowie, The Cars, Guns N' Roses, AC/DC, Aerosmith, Fleetwood Mac, Red Hot Chili Peppers, The Doors, Buddy Guy, B.B. King, Freddie King, Chuck Berry, Miles Davis, John Coltrane</p>
        <h4>Favorite Guitarists</h4>
        <p>Jimmy Page, Eric Clapton, Mick Taylor, Slash, George Harrison, Elliot Easton, Angus Young, Joe Perry, John Frusciante, Eddie Van Halen, Jeff Beck, Jerry Cantrell, Robby Krieger, Buddy Guy, B.B. King, Freddie King, Chet Atkins, Scotty Moore, Chuck Berry</p>
        <h4>Favorite Singers</h4>
        <p>Layne Staley, Paul McCartney, John Lennon, Jim Morrison, Jerry Cantrell, Freddie Mercury, Roger Daltrey, George Harrison</p>
      </div>
    );
  }
  
  export default Influences;
  
